/**
 * API service for HTTP requests
 */

import { API_ENDPOINTS, PROJECT_ID } from '../constants/Defaults.js';

export class ApiService {
  constructor(options = {}) {
    this.options = options;
    this.baseUrl = options.baseUrl || '';
  }

  /**
   * Make a GET request
   * @param {string} url - Request URL
   * @param {Object} options - Request options
   * @returns {Promise} - Response promise
   */
  async get(url, options = {}) {
    return this.request(url, {
      method: 'GET',
      ...options
    });
  }

  /**
   * Make a POST request
   * @param {string} url - Request URL
   * @param {Object} data - Request data
   * @param {Object} options - Request options
   * @returns {Promise} - Response promise
   */
  async post(url, data = {}, options = {}) {
    return this.request(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...options.headers
      },
      body: JSON.stringify(data),
      ...options
    });
  }

  /**
   * Make a generic request
   * @param {string} url - Request URL
   * @param {Object} options - Request options
   * @returns {Promise} - Response promise
   */
  async request(url, options = {}) {
    const fullUrl = this.baseUrl + url;
    
    try {
      const response = await fetch(fullUrl, options);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error('API request failed:', error);
      throw error;
    }
  }

  /**
   * Search flows
   * @param {string} query - Search query
   * @param {Object} options - Search options
   * @returns {Promise} - Search results
   */
  async searchFlows(query, options = {}) {
    const searchData = {
      query,
      project_id: PROJECT_ID,
      limit: options.limit || 3,
      ...options
    };

    return this.post(API_ENDPOINTS.search, searchData);
  }

  /**
   * Get flow details
   * @param {string} flowId - Flow ID
   * @returns {Promise} - Flow details
   */
  async getFlowDetails(flowId) {
    return this.get(`${API_ENDPOINTS.flowDetails}/${flowId}`);
  }

  /**
   * Check if API is available
   * @returns {Promise<boolean>} - True if API is available
   */
  async isAvailable() {
    try {
      await this.get(API_ENDPOINTS.search);
      return true;
    } catch (error) {
      return false;
    }
  }
} 